import { render, staticRenderFns } from "./machine-vision.vue?vue&type=template&id=78738556&scoped=true&"
import script from "./machine-vision.vue?vue&type=script&lang=js&"
export * from "./machine-vision.vue?vue&type=script&lang=js&"
import style0 from "./machine-vision.vue?vue&type=style&index=0&id=78738556&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78738556",
  null
  
)

export default component.exports